import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from "@openng/optimus-ui/dynamicdialog";
import { ButtonComponent } from "../button/button.component";
import { TranslateService } from "@ngx-translate/core";
import { RepairRequestComponent } from "../repair-request/repair-request.component";
import { PermissionService } from "../../../services/api/permission/permission.service";
import { REPAIR_STATUS } from "../../../enums/repairStatus.enum";

@Component({
  standalone: true,
  selector: "app-fix-link",
  imports: [ButtonComponent],
  templateUrl: "./fix-link.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./fix-link.component.scss",
})
export class FixLinkComponent {
  private ref = inject(DynamicDialogRef);
  private config = inject(DynamicDialogConfig);
  private sanitizer = inject(DomSanitizer);
  private translate = inject(TranslateService);
  private dialogService = inject(DialogService);

  public permissions = inject(PermissionService);
  public fixLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.config.data.fixLink);
  public repairStatus = this.config.data.repairStatus;

  public REPAIR_STATUS = REPAIR_STATUS;

  public repairRequestRef: DynamicDialogRef | null = null;

  public cancel() {
    this.ref.close(null);
  }

  public noRequest() {
    this.ref.close("no_request");
  }

  public request() {
    this.repairRequestRef = this.dialogService.open(RepairRequestComponent, {
      header: this.translate.instant("gate_faults.repair_modal.title.request_attachments"),
      data: { gateFaultId: this.config.data.gateFaultId },
      modal: true,
      width: "48vw",
      contentStyle: { overflow: "auto", padding: "20px" },
      breakpoints: { "960px": "75vw", "640px": "90vw" },
      closable: true,
    });

    this.repairRequestRef?.onClose.subscribe({
      next: (res) => {
        if (res) {
          this.ref.close(res);
        }
      },
    });
  }
}
